import { Popover as BasePopover } from '@base-ui/react/popover';
import type { ReactNode } from 'react';

export interface PopoverProps {
  triggerLabel: ReactNode;
  title?: ReactNode;
  children: ReactNode;
}

export function Popover({ triggerLabel, title, children }: PopoverProps) {
  return (
    <BasePopover.Root>
      <BasePopover.Trigger className="ui-button ui-button--secondary ui-button--md">
        <span className="ui-button__label">{triggerLabel}</span>
      </BasePopover.Trigger>
      <BasePopover.Portal>
        <BasePopover.Positioner className="ui-positioner">
          <BasePopover.Popup className="ui-popover__popup">
            {title ? <BasePopover.Title className="ui-popover__title">{title}</BasePopover.Title> : null}
            <div className="ui-popover__body">{children}</div>
            <BasePopover.Arrow className="ui-popover__arrow" />
          </BasePopover.Popup>
        </BasePopover.Positioner>
      </BasePopover.Portal>
    </BasePopover.Root>
  );
}
